<template>
  <div class="header">
    <div class="header_left">
      <div class="one">
        <img
          class="menuBtn"
          @click="drawer = true"
          style="cursor: pointer;"
          src="@/assets/img/9.png"
          alt
        />
        <el-drawer
          title
          size="260px"
          :with-header="false"
          :visible.sync="drawer"
          :modal="false"
          :direction="direction"
        >
          <div class="elDrawerBox">
            <li @click="intoMarket()">
              <img src="@/assets/img/16.png" alt />
              <span>上市公司</span>
            </li>
            <li @click="pharmaPage()">
              <img src="@/assets/img/17.png" alt />
              <span>医药公司</span>
            </li>
          </div>
        </el-drawer>
      </div>
      <div class="two">
        <img src="@/assets/img/10.png" alt />
      </div>
      <div class="three">
        <img @click="indexTab" style="cursor: pointer;" src="@/assets/img/11.png" alt />
      </div>
    </div>
    <div class="header_right">
      <!-- 搜索 -->
      <div class="addTopSearch">
        <div class="topSearch">
          <el-input
            placeholder="请输入企业名称"
            v-model="companyName"
            @keyup.enter.native="searchEnterFun"
          >
            <el-button slot="append" @click="searchHand">
              <img src="@/assets/img/搜索.png" alt />
            </el-button>
          </el-input>
        </div>
      </div>

      <div class="catalog">
        <img src="@/assets/img/2.png" alt class="user" />
        <span v-show="users.token">您好，{{users.userName}}</span>
        <span v-show="users.token">|</span>
        <span v-show="users.token" @click="addCollect" style="cursor: pointer;">我的收藏</span>
        <span v-show="users.token">|</span>
        <span v-show="users.token" @click="unloginFn" style="cursor: pointer;">退出登录</span>
        <span v-show="!users.token" @click="goLoginPage" style="cursor: pointer;">登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import $ from "jquery";
import magic from "@/../static/common/magic.js";

export default {
  props: {},
  components: {},
  data() {
    return {
      companyName: "", //传参
      drawer: false,
      direction: "ltr",
      users: "", //登录信息
      guid: ''
    };
  },
  computed: {},
  watch: {
    guid(val){
      if(val){
        this.loginFn();
      }
    }
  },
  methods: {
    //跳往登录页面
    goLoginPage() {
      // console.log(window.location.href,'testUrl');
      this.$router.push({ 
        path: "/login",
        query: {
          repath: window.location.href
        } 
      });
    },
    //判断是否有权限
    ifRightsFn() {
      return new Promise(function(resolve, reject) {
        let productId = "";
        if (that.$route.query.dbcode) {
          productId =
            that.$route.query.dbcode == 2
              ? 0
              : that.$route.query.dbcode == 1
              ? 1
              : "";
        }

        if (that.$route.params.dbcode) {
          productId =
            that.$route.params.dbcode == 2
              ? 0
              : that.$route.params.dbcode == 1
              ? 1
              : "";
        }

        if (productId == 0 || productId == 1) {
          api.weighterRights(productId).then(res => {
            resolve(res.data);
          });
        } else {
          resolve(false);
        }
      });
    },
    loginFn() {
      let _this = this;
      let tmpGuid = this.guid;
      api.iflogin(tmpGuid).then(res => {
        if (res.UserToken) {
          _this.ifRightsFn().then(ress => {

            let tmpObj = {
              loginId: res.Logined,
              token: res.UserToken,
              userName: res.UserName,
              rights: ress ? 1 : 0,
              userId: res.userId
            }
            console.log(tmpObj,'tmpObj')

            localStorage.setItem('usersInfo', JSON.stringify(tmpObj));

            sessionStorage.setItem("Authorization",res.UserToken);

            _this.users = tmpObj;

            _this.$emit("getLoginInfo", tmpObj);
          });
        }else{
          localStorage.removeItem("usersInfo");
          sessionStorage.removeItem("Authorization");

          _this.users = "";

          _this.$emit("getLoginInfo", "");
        }
      });
    },
    //退出登录
    unloginFn() {
      let _this = this;
      let tmpGuid = this.guid;
      api.unlogin(tmpGuid).then(res => {
        $.ajax({
          url: "http://d.drcnet.com.cn/login/login.ashx?flag=logoutp", //initp 查询目前用户登录状态，logoutp 退出登录
          type: "post",
          dataType: "jsonp", //指定服务器返回的数据类型
          jsonpCallback: "showDatas", //指定回调函数名称
          xhrFields: { withCredentials: true },
          crossDomain: true,
          async: false,
          success: function(data) {
            
            if (!res.code) {
              localStorage.removeItem("usersInfo");
              sessionStorage.removeItem("Authorization");

              _this.users = "";

              _this.$emit("getLoginInfo", "");

              window.history.go(0);
            }
          }
        });
      });
    },

    // 库 上市
    intoMarket() {
      this.$router.push({
        path: "/upmarket",
        query: {
          dbcode: 2
        }
      });
      this.drawer = false;
    },

    // 库 医药
    pharmaPage() {
      this.$router.push({
        path: "/pharma",
        query: {
          dbcode: 1
        }
      });
      this.drawer = false;
    },
    indexTab() {
      this.$router.push({ path: "/index" });
    },
    // 回车搜索
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        let companyName = magic.getUrlKey("companyName") ? magic.getUrlKey("companyName") : null;
        let dbcode = magic.getUrlKey("dbcode");
        let pageNo = magic.getUrlKey("pageNo");
        let pageSize = magic.getUrlKey("pageSize");
        
        let urlString = window.location.hash.substring(2,8);
        let comName = this.companyName ? this.companyName : null;
        if(urlString == 'search' && companyName == comName){
          // alert(1)
        }else{
          this.$router.push({
            path: "/search",
            query: {
              companyName: this.companyName,
              dbcode: 2,
              pageNo: 1,
              pageSize: 10
            }
          });
        }
        // 埋点
        try{
            //LogCollection.contents["key"]="value";
            //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
            //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
            LogCollection.send(9);
        }catch(e){}
      }
    },
    // 搜索
    searchHand() {
      let companyName = magic.getUrlKey("companyName") ? magic.getUrlKey("companyName") : null;
      let dbcode = magic.getUrlKey("dbcode");
      let pageNo = magic.getUrlKey("pageNo");
      let pageSize = magic.getUrlKey("pageSize");
      
      let urlString = window.location.hash.substring(2,8);
      let comName = this.companyName ? this.companyName : null;
      if(urlString == 'search' && companyName == comName){
        // alert(1)
      }else{
        this.$router.push({
          path: "/search",
          query: {
            companyName: this.companyName,
            dbcode: 2,
            pageNo: 1,
            pageSize: 10
          }
        });
      }
    },
    // 我的收藏
    addCollect() {
      this.$router.push({
        path: "/storeup",
        query: {
          dbcode: this.$route.query.dbcode ? that.$route.query.dbcode : 2
        }
      });
    },
    figgerPrint(){
      let _this = this;

      // let myOptions = {
      //   excludes: {
      //     language: true,
      //     colorDepth: true,
      //     deviceMemory: true,
      //     pixelRatio: true,
      //     availableScreenResolution: true,
      //     timezoneOffset: true,
      //     timezone: true,
      //     sessionStorage: true,
      //     localStorage: true,
      //     indexedDb: true,
      //     addBehavior: true,
      //     openDatabase: true,
      //     cpuClass: true,
      //     doNotTrack: true,
      //     plugins: true,
      //     canvas: true,
      //     webglVendorAndRenderer: true,
      //     adBlock: true,
      //     hasLiedLanguages: true,
      //     hasLiedResolution: true,
      //     hasLiedOs: true,
      //     hasLiedBrowser: true,
      //     touchSupport: true,
      //     audio: false,
      //     enumerateDevices: true,
      //     hardwareConcurrency: true,
      //   },
      // };
      let myOptions = getDRCNetFingerConfig();

      if (window.requestIdleCallback) {
        // console.log(Fingerprint2,'Fingerprint2')
        Fingerprint2.get(myOptions, function(components) {
          // console.log(myOptions,'myOptions');
          var option=components.filter(function (pair) {
            if(pair.key=="userAgent"||pair.key=="availableScreenResolution"){
              return false; 
            }
            return true;
          }).map(function (pair) {
            return pair.value;
          });
          var murmur = Fingerprint2.x64hash128(option.join(), 31);
          // document.querySelector("#fp").textContent = murmur;
          _this.guid = murmur;
          console.log(murmur,'murmur')
        })
      } else {
        setTimeout(()=>{
          // console.log(Fingerprint2,'Fingerprint2')
          Fingerprint2.get(myOptions, function(components) {
            // console.log(components,'components');
            var option=components.filter(function (pair) {
              if(pair.key=="userAgent"||pair.key=="availableScreenResolution"){
                return false; 
              }
              return true;
            }).map(function (pair) {
              return pair.value;
            });
            var murmur = Fingerprint2.x64hash128(option.join(), 31);
            // document.querySelector("#fp").textContent = murmur;
            _this.guid = murmur;
            console.log(murmur,'murmur')
          })
        },500);
      }
    },
  },
  created() {
    window.that = this;
    this.figgerPrint();
  },
  mounted() {}
};
</script>
<style scoped lang="less">
.header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  background: #054dc6;
}
.header_left {
  width: auto;
  height: 60px;
  line-height: 40px;
  display: flex;
  .one {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    .menuBtn {
      width: 19px;
      height: 16px;
      vertical-align: middle;
    }
    /deep/ .el-drawer__open .el-drawer.ltr {
      margin-top: 60px;
    }
    .elDrawerBox {
      width: 90%;
      margin: 6px 20px 0px 20px;
      font-size: 16px;
      li {
        width: 220px;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #c8c8c8;
        cursor: pointer;
        display: inline-block;
        display: flex;
        img {
          width: 22px;
          height: 22px;
          transform: translate(0%, 60%);
          padding-right: 5px;
        }
      }
    }
  }
  .two {
    width: 2px;
    height: 60px;
  }
  .three {
    width: 317px;
    height: 38px;
    padding: 9px 0px 13px 12px;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.header_right {
  padding-right: 25px;
  height: 60px;
  line-height: 60px;
  display: flex;
  .addTopSearch {
    padding-right: 25px;
    display: flex;
    align-items: center; /*水平居中*/
    justify-content: center; /*垂直居中*/
  }
  // 搜索
  .topSearch {
    width: auto;
    height: auto;
    display: flex;
    align-items: center; /*水平居中*/
    justify-content: center; /*垂直居中*/
    /deep/ .el-input-group {
      width: 340px;
      height: 36px;
    }
    /deep/ .el-input-group--append .el-input__inner,
    .el-input-group__prepend {
      height: 36px;
    }
    /deep/ .el-input-group__append {
      background: #2f77ee;
      border: 1px solid #488bf9;
      border-radius: 0px 2px 2px 0px;
    }
    /deep/ .el-icon-search {
      color: #fff;
    }
    /deep/ .el-input__inner {
      border-radius: 2px 0px 0px 2px;
      border: 1px solid #488bf9;
    }
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
      padding: 0 15px;
    }
  }
  span {
    width: 83px;
    height: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(236, 241, 248, 1);
    line-height: 26px;
    padding-right: 5px;
  }
  .user {
    transform: translate(0, 25%);
    width: 26px;
    height: 26px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header2.vue